import Layouts from './src/Layouts.vue'

Layouts.install = function(Vue) {
  Vue.component(Layouts.name, Layouts)
}

export default Layouts
